import {CutOutPreview} from "./cutOutPreview";
import {placeableWalls} from "./cutOutGeneration";

export class WindowPreview extends CutOutPreview {
    constructor(width, height, bottomOffset) {
        bottomOffset = bottomOffset !== null && !isNaN(bottomOffset) ? bottomOffset : 0;
        super(width, height, bottomOffset);
        this.placeableWalls = placeableWalls.exterior;
    }

    static createFromControlObject(controlObject) {
        let width = controlObject.userData.width;
        let height = controlObject.userData.height;
        let bottomOffset = controlObject.userData.bottomOffset;

        let preview = new WindowPreview(width, height, bottomOffset);
        preview.object = controlObject;
        preview.recreated = true;
        return preview;
    }
}
